TvaController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'ModalService',
    'PaginationService',
    'TvaService',
    'notification',
    '$transitions',
    'MOPService'
];

export default function TvaController(
    $scope,
    $state,
    $stateParams,
    $translate,
    ModalService,
    PaginationService,
    TvaService,
    notification,
    $transitions,
    MOPService
) {
    const vm = this;
    const watchers = [];

    let previousTableState;
    vm.selectedTvaId = undefined;
    vm.lastSelected = undefined;

    vm.loading = false;
    vm.params = $stateParams;
    vm.state = $state;
    vm.tva = [];

    vm.slideWidth = '500px';
    vm.slideMargin = {
        'margin-right': '0px',
        'transition-duration': '0.5s',
        'transition-animation': 'margin-right',
        height: '100%'
    };

    vm.itemsByPageOptions = [20, 100, 200];
    vm.itemsByPage = vm.itemsByPageOptions[0];

    vm.selectTva = selectTva;
    vm.isTvaSelected = isTvaSelected;
    vm.showDetail = showDetail;
    vm.closeDetail = closeDetail;
    vm.loadTva = loadTva;
    vm.deleteTva = deleteTva;
    vm.setSelected = setSelected;
    vm.eraseAllFilters = eraseAllFilters;
    vm.MOPService = MOPService;

    function init() {
        vm.MOPService.setMop([{ title: 'TVA.BREADCRUMBS.TVA_LIST', filename: 'TauxTVA.pdf', application: 'gestion' }]);
        $transitions.onSuccess({}, stateChangeSuccessFunc);
        watchers.push($scope.$on('$destroy', dispose));

        if (shouldSetSelectedId()) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }
    }

    init();

    vm.$onDestroy = () => {
        vm.MOPService.resetMop();
    };

    function stateChangeSuccessFunc(event, toState) {
        if (!$state.params.id) {
            vm.setSelected();
        } else if ($state.params.id) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }
    }

    function setSelected(tva) {
        if (tva && tva.id) {
            vm.selectedTvaId = $stateParams.id;
            vm.lastSelected = vm.selectedTvaId;
            vm.slideMargin['margin-right'] = vm.slideWidth;
        } else {
            vm.selectedTvaId = undefined;
            vm.slideMargin['margin-right'] = '0px';
        }
    }

    function shouldSetSelectedId() {
        return $state && $state.current && $state.current.name && $state.current.name === 'tva.list.detail' && $stateParams && $stateParams.id;
    }

    function selectTva(tva) {
        if (tva && tva.id) {
            if (vm.selectedTvaId !== tva.id) {
                vm.selectedTvaId = tva.id;
                showDetail(tva.id);
            } else {
                vm.selectedTvaId = undefined;
                closeDetail();
            }
        }
    }

    function isTvaSelected(tva) {
        return tva && tva.id && vm.selectedTvaId === tva.id;
    }

    function showDetail(tvaId) {
        $state.go('tva.list.detail', { id: tvaId });
    }

    function closeDetail() {
        $state.go('tva.list');
    }

    async function loadTva(tableState) {
        startLoading();

        if ($state && $state.current && $state.current.name !== 'tva.list') {
            $state.go('tva.list');
        }

        if (tableState) {
            previousTableState = tableState;
        }

        const filters = PaginationService.getFilters(previousTableState);
        const sorts = PaginationService.getSorts(previousTableState);
        const pagination = PaginationService.getPagination(previousTableState);

        vm.tva = [];

        try {
            const data = await TvaService.getList(filters, sorts, pagination);
            vm.tva = data.items;

            if (previousTableState) {
                PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
            }
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            stopLoading();
        }
    }

    async function deleteTva(tva) {
        if (tva /*&& tva.canDelete*/ && tva.id) {
            const modalInstance = ModalService.confirm({
                modalTitle: $translate.instant('TVA.DELETE.TITLE', { code: tva.taux }),
                modalMsg: $translate.instant('TVA.DELETE.MESSAGE'),
                headerClass: 'modal-danger'
            });

            modalInstance.result.then(async function () {
                startLoading();
                try {
                    await TvaService.deleteTvaById(tva.id);
                    notification.success($translate.instant('TVA.DELETE.SUCCESS'));

                    vm.selectedTvaId = undefined;

                    if (vm.params.id) {
                        vm.state.go('tva.list');
                    }

                    previousTableState = PaginationService.getTableStateAfterDelete(previousTableState, previousTableState.pagination.take);

                    loadTva();
                } catch (ex) {
                    notification.error(ex.data);
                } finally {
                    stopLoading();
                }
            });
        }
    }

    function eraseAllFilters() {
        loadTva();
    }

    function startLoading() {
        vm.loading = true;
    }

    function stopLoading() {
        vm.loading = false;
    }

    function dispose() {
        watchers.forEach((x) => x());
    }
}
